<template>
  <div class="mt-6">
    <p class="text-lg font-bold text-root-2">Customers</p>
    <div class="mt-6" v-if="isLoading">
      <spinner
        size="medium"
        :spacing="40"
        message=""
        :line-fg-color="$primaryColor"
      />
    </div>
    <div v-else class="card bg-root p-6 mt-4">
      <customer-table
        :tableData="customersInfo"
        :page="page"
        @getCustomers="getCustomers"
        tableType="allCustomersTable"
      />
    </div>
  </div>
</template>

<script>
import getCustomers from '@/mixins/externalApi'
export default {
  name: 'AllCustomers',
  mixins: [getCustomers],
  data () {
    return {
      isLoading: false,
      payload: {
        page: 1,
        size: 10,
        status: '',
        type: '',
        from: '',
        to: ''
      }
    }
  },
  components: {
    CustomerTable: () =>
      import('@/components/externalApi/tables/CustomerTable.vue')
  },
  computed: {
    customersInfo () {
      return this.$store.state.externalApi.customers.items || []
    },
    page () {
      return this.$store.state.externalApi.customers.page || {}
    }
  },
  mounted () {
    this.getCustomers()
  }
}
</script>

<style scoped>
.card {
  box-shadow:
    0px 0px 1px rgba(3, 2, 7, 0.12),
    0px 2px 4px rgba(3, 2, 7, 0.12);
  border-radius: 15px;
}
</style>
